module.exports = __webpack_public_path__ + "static/media/timelapse_6.1225413e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_6.jpg
// module id = 966
// module chunks = 0